/***** ################## API's Service Route's Defining ##################
 */

export const baseUrl = process.env.REACT_APP_baseUrl;

/**
 * ## Sub Routes Defining
 */

export const LOGIN = "/auth/admin/login";
export const CHANGE_PASSWORD = "/change-password/";
export const DASHBOARD = "/admin/dashboard";

export const REGION_LIST = "/regions/list";
export const REGION_LIST_DROPDOWN = "/regions/list/dropdown";
export const REGION_EDIT = "/region/edit/";
export const REGION_CREATE = "/region/create/";
export const REGION_UPDATE = "/region/update/";
export const REGION_DELETE = "/region/delete/";

export const COUNTRY_LIST = "/countrys/list";
export const COUNTRY_LIST_DROPDOWN = "/countrys/list/dropdown";
export const COUNTRY_EDIT = "/country/edit/";
export const COUNTRY_CREATE = "/country/create/";
export const COUNTRY_UPDATE = "/country/update/";
export const COUNTRY_DELETE = "/country/delete/";

export const STATE_LIST = "/states/list";
export const STATE_LIST_DROPDOWN = "/states/list/dropdown";
export const STATE_EDIT = "/state/edit/";
export const STATE_CREATE = "/state/create/";
export const STATE_UPDATE = "/state/update/";
export const STATE_DELETE = "/state/delete/";

export const USER_LIST = "/users/list";
export const USER_LIST_DROPDOWN = "/users/list/dropdown";
export const USER_EDIT = "/user/edit/";
export const USER_CREATE = "/user/create/";
export const USER_UPDATE = "/user/update/";
export const USER_DELETE = "/user/delete/";
export const USER_CHANGE_CHAPTER = "/user/change-chapter/";
export const USER_IMPORT = "/user/import";
export const USER_SEND_WELCOME_EMAILS = "/users/send-pending-welcome-emails";

export const COUNTRY_ADMIN_USER_LIST = "/country-admin-users/list";
export const COUNTRY_ADMIN_USER_EDIT = "/country-admin-user/edit/";
export const COUNTRY_ADMIN_USER_CREATE = "/country-admin-user/create/";
export const COUNTRY_ADMIN_USER_UPDATE = "/country-admin-user/update/";
export const COUNTRY_ADMIN_USER_DELETE = "/country-admin-user/delete/";

export const STATE_ADMIN_USER_LIST = "/state-admin-users/list";
export const STATE_ADMIN_USER_EDIT = "/state-admin-user/edit/";
export const STATE_ADMIN_USER_CREATE = "/state-admin-user/create/";
export const STATE_ADMIN_USER_UPDATE = "/state-admin-user/update/";
export const STATE_ADMIN_USER_DELETE = "/state-admin-user/delete/";

export const CHAPTER_ADMIN_USER_LIST = "/chapter-admin-users/list";
export const CHAPTER_ADMIN_USER_EDIT = "/chapter-admin-user/edit/";
export const CHAPTER_ADMIN_USER_CREATE = "/chapter-admin-user/create/";
export const CHAPTER_ADMIN_USER_UPDATE = "/chapter-admin-user/update/";
export const CHAPTER_ADMIN_USER_DELETE = "/chapter-admin-user/delete/";

export const REGION_ADMIN_USER_LIST = "/region-admin-users/list";
export const REGION_ADMIN_USER_EDIT = "/region-admin-user/edit/";
export const REGION_ADMIN_USER_CREATE = "/region-admin-user/create/";
export const REGION_ADMIN_USER_UPDATE = "/region-admin-user/update/";
export const REGION_ADMIN_USER_DELETE = "/region-admin-user/delete/";

export const CHAPTER_LIST = "/chapters/list";
export const CHAPTER_LIST_DROPDOWN = "/chapters/list/dropdown";
export const CHAPTER_EDIT = "/chapter/edit/";
export const CHAPTER_CREATE = "/chapter/create/";
export const CHAPTER_UPDATE = "/chapter/update/";
export const CHAPTER_DELETE = "/chapter/delete/";

export const USER_ROLE_LIST = "/user-roles/list";
export const USER_ROLE_LIST_DROPDOWN = "/user-roles/list/dropdown";
export const USER_ROLE_EDIT = "/user-role/edit/";
export const USER_ROLE_CREATE = "/user-role/create/";
export const USER_ROLE_UPDATE = "/user-role/update/";
export const USER_ROLE_DELETE = "/user-role/delete/";

export const CATEGORY_LIST = "/category/list";
export const CATEGORY_LIST_DROPDOWN = "/category/list/dropdown";
export const CATEGORY_EDIT = "/category/edit/";
export const CATEGORY_CREATE = "/category/create/";
export const CATEGORY_UPDATE = "/category/update/";
export const CATEGORY_DELETE = "/category/delete/";

export const BLOOD_GROUP_LIST = "/blood-groups/list";
export const BLOOD_GROUP_LIST_DROPDOWN = "/blood-groups/list/dropdown";
export const BLOOD_GROUP_EDIT = "/blood-group/edit/";
export const BLOOD_GROUP_CREATE = "/blood-group/create/";
export const BLOOD_GROUP_UPDATE = "/blood-group/update/";
export const BLOOD_GROUP_DELETE = "/blood-group/delete/";

export const TIMER_LIST = "/timers/list";
export const TIMER_EDIT = "/timer/edit/";
export const TIMER_CREATE = "/timer/create/";
export const TIMER_UPDATE = "/timer/update/";
export const TIMER_DELETE = "/timer/delete/";

export const TIMER_ACCESS_GET = "/timer-access/get";
export const TIMER_ACCESS_UPDATE = "/timer-access/update";

export const ROLE_LIST = "/roles/list";
export const ROLE_LIST_DROPDOWN = "/roles/list/dropdown";
export const ROLE_EDIT = "/role/edit/";
export const ROLE_CREATE = "/role/create/";
export const ROLE_UPDATE = "/role/update/";
export const ROLE_DELETE = "/role/delete/";
export const PERMISSION_LIST = "/permissions/list/";

export const CROWN_LIST_DROPDOWN = "/crowns/list/dropdown";

export const TYFCB_LIST = "/tyfcbs/list";

export const MEETING_SCHEDULE_LIST = "/meetings/schedules/list";
export const MEETING_STATUS_UPDATE = "/meeting/status/update/";

export const ONE_TO_ONE_LIST = "/one-to-one/list";

export const REFERRAL_LIST = "/referrals/list";

export const VISITOR_LIST = "/visitors/list";
export const VISITOR_GENERAL_LIST = "/visitors/list";
export const VISITOR_CHIEF_GUEST_LIST = "/visitors/list";
export const VISITOR_POWER_DATE_LIST = "/visitors/list";
export const VISIT_STATUS_UPDATE = "/visit/status/update/";

export const WEEKLY_MEETINGS_LIST = "/weekly-meetings/list";
export const MEETING_EDIT = "/weekly-meeting/edit/";
export const MEETING_UPDATE = "/weekly-meeting/update/";
export const MEETING_SCHEDULES_REGISTRY = "/weekly-meetings/schedules/registry/";
export const MEETING_SCHEDULES_REGISTRY_STATUS_UPDATE = "/weekly-meetings/schedules/registry/status/update/";
export const MEETING_FEES_REGISTRY = "/weekly-meetings/fees/registry/";
export const MEETING_FEES_REGISTRY_STATUS_UPDATE = "/weekly-meetings/fees/registry/status/update/";
export const FEES_EDIT = "/fees/edit/";
export const FEES_UPDATE = "/fees/update/";

export const MEETING_MONTHLY_FEES_LIST = "/meetings/monthly-fees/list";
export const MEETING_MONTHLY_FEES_STATUS_UPDATE = "/meeting/monthly-fees/status/update/";

export const EVENT_LIST = "/events/list";
export const EVENT_EDIT = "/event/edit/";
export const EVENT_CREATE = "/event/create/";
export const EVENT_UPDATE = "/event/update/";
export const EVENT_DELETE = "/event/delete/";

export const EVENT_REGISTRY = "/events/registry/";
export const EVENT_REGISTRY_STATUS_UPDATE = "/events/registry/status/update/";

export const NEWS_LIST = "/news/list";
export const NEWS_EDIT = "/news/edit/";
export const NEWS_CREATE = "/news/create/";
export const NEWS_UPDATE = "/news/update/";
export const NEWS_DELETE = "/news/delete/";

export const TESTIMONIAL_LIST = "/testimonials/list";

export const POINTS_LIST = "/points/list";
export const POINTS_LOG_LIST = "/points-log/list";
export const POINTS_SYSTEM_LIST = "/points-system";

export const MEETING_SCHEDULE = "/meetings/schedule";

//reports
export const TYFCB_REPORTS_LIST = "/reports/tyfcbs/list";
export const BIZ_GIVEN_REPORTS_LIST = "/reports/biz-given/list";
export const ONE_TO_ONE_REPORTS_LIST = "/reports/one-to-one/list";
export const REFERRALS_REPORTS_LIST = "/reports/referrals/list";
export const VISITORS_REPORTS_LIST = "/reports/visitors/list";
export const FEES_REPORTS_LIST = "/reports/fees/list";
export const ATTENDANCE_REPORTS_LIST = "/reports/attendance/list";
export const OVERALL_REPORTS_LIST = "/reports/overall/list";
export const MEMBERSHIP_EXPIRY_AND_RENEWAL_REPORTS_LIST = "/reports/membership-expiry-and-renewals/list";